/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import styled from 'styled-components';

import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { entiyFeatureType } from 'types';

import Spinner from 'components/Spinner';
import SuggestionsAutocomplete from './components/SuggestionsAutocomplete';

import './style.scss';

const SSpinner = styled(Spinner)`
  &&& {
    right: 15px;
    transform: translateY(-50%);
  }
`;

const TagsAutocompleteInput = ({
  autoOpen,
  getSuggestions,
  inputProps,
  isDisabled,
  item,
  tagProps,
  validationRegex,
  value,
  withAddOption,
  onAddTag,
  onChangeValues,
  onAddOption,
  onSearch,
  suggestionItemComponent,
}) => {
  const handleChangeValues = equalsValues => {
    onChangeValues(equalsValues, item);
  };

  // https://github.com/olahol/react-tagsinput/blob/master/example/components/autocomplete.js
  /* eslint-disable react/prop-types */
  const autocompleteRenderInput = ({ addTag, isLoading, ...inputProps }) => {
    const handleAddTag = selectedTag => {
      const tag = selectedTag.name || selectedTag;

      if (onAddTag) {
        onAddTag(selectedTag);
      }

      addTag(tag);
    };

    return (
      <>
        <SuggestionsAutocomplete
          addTag={handleAddTag}
          autoOpen={autoOpen}
          data-test="suggestions-autocomplete"
          getSuggestions={getSuggestions}
          inputProps={inputProps}
          isNotUnique={value.indexOf(inputProps.value) >= 0}
          suggestionItemComponent={suggestionItemComponent}
          withAddOption={withAddOption}
          onAddOption={onAddOption}
          onSearch={onSearch}
        />
        {isLoading && <SSpinner isBlue />}
      </>
    );
  };

  const renderTag = props => {
    const {
      tag,
      key,
      disabled,
      onRemove,
      classNameRemove,
      getTagDisplayValue,
      ...other
    } = props;

    return (
      <span key={key} {...other} data-test={`tag-box-${key}`}>
        {getTagDisplayValue(tag)}
        {!disabled && (
          <a
            className={classNameRemove}
            data-test="tagsinput-remove"
            onClick={() => onRemove(key)}
          />
        )}
      </span>
    );
  };

  return (
    <TagsInput
      onlyUnique
      disabled={isDisabled}
      inputProps={inputProps}
      renderInput={autocompleteRenderInput}
      renderTag={renderTag}
      tagProps={{
        className: 'react-tagsinput-tag',
        classNameRemove: 'react-tagsinput-remove',
        ...tagProps,
      }}
      validationRegex={validationRegex}
      value={value}
      onChange={handleChangeValues}
    />
  );
};

TagsAutocompleteInput.propTypes = {
  autoOpen: PropTypes.bool,
  getSuggestions: PropTypes.func,
  inputProps: PropTypes.shape({
    className: PropTypes.string,
    placeholder: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  item: entiyFeatureType,
  suggestionItemComponent: PropTypes.oneOfType([PropTypes.object]),
  tagProps: PropTypes.shape({
    className: PropTypes.string,
    classNameRemove: PropTypes.string,
  }),
  validationRegex: PropTypes.shape({}),
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  withAddOption: PropTypes.string,
  onAddOption: PropTypes.func,
  onAddTag: PropTypes.func,
  onChangeValues: PropTypes.func,
  onSearch: PropTypes.func,
};

TagsAutocompleteInput.defaultProps = {
  withAddOption: '',
  onAddOption: noop,
  autoOpen: false,
  suggestionItemComponent: null,
};

export default TagsAutocompleteInput;
